export default {
  side: {
    type: String,
    default: 'left'
  },
  freezeScreen: {
    type: Boolean,
    default: true
  },
  hideOnBlur: {
    type: Boolean,
    default: true
  },
  show: Boolean
}



// WEBPACK FOOTER //
// ./src/components/Drawer/_props.js